<script lang="ts" setup>
//#region Imports

import IconCheck from '@/shared/icons/IconCheck.vue';

//#endregion
</script>

<template>
  <div class="status-done">
    <IconCheck />
  </div>
</template>

<style lang="scss">
.status-done {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--success);
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
  margin-top: 1rem;

  svg {
    color: var(--white);
    display: block;
    width: 3rem;
    height: 3rem;
  }
}
</style>
